/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiTemplate } from './BridgeApiTemplate';
import {
    BridgeApiTemplateFromJSON,
    BridgeApiTemplateFromJSONTyped,
    BridgeApiTemplateToJSON,
    BridgeApiTemplateToJSONTyped,
} from './BridgeApiTemplate';

/**
 * 
 * @export
 * @interface BridgeTemplatesPage
 */
export interface BridgeTemplatesPage {
    /**
     * 
     * @type {number}
     * @memberof BridgeTemplatesPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof BridgeTemplatesPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof BridgeTemplatesPage
     */
    total: number;
    /**
     * 
     * @type {Array<BridgeApiTemplate>}
     * @memberof BridgeTemplatesPage
     */
    content: Array<BridgeApiTemplate>;
}

/**
 * Check if a given object implements the BridgeTemplatesPage interface.
 */
export function instanceOfBridgeTemplatesPage(value: object): value is BridgeTemplatesPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function BridgeTemplatesPageFromJSON(json: any): BridgeTemplatesPage {
    return BridgeTemplatesPageFromJSONTyped(json, false);
}

export function BridgeTemplatesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeTemplatesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(BridgeApiTemplateFromJSON)),
    };
}

export function BridgeTemplatesPageToJSON(json: any): BridgeTemplatesPage {
    return BridgeTemplatesPageToJSONTyped(json, false);
}

export function BridgeTemplatesPageToJSONTyped(value?: BridgeTemplatesPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(BridgeApiTemplateToJSON)),
    };
}

